import { OFFLINE_PARTNER_SHEET_SETUP_KEY } from '@/constants/storageKeys';

/**
 * The OAuth callback carries no offline-partner context, so the Sheets setup
 * stashes it here before redirecting to Google and `pages/oauth/callback.vue`
 * picks it back up.
 */
type OfflineSheetSetupType = {
  /* The OAuth state token, echoed back on the callback whether it succeeded or
     failed, so a stale stash cannot divert an unrelated one */
  state: string;
  offlinePartnerId: string;
  offlinePartnerUuid: string;
};

export function saveOfflineSheetSetup(setup: OfflineSheetSetupType) {
  sessionStorage.setItem(
    OFFLINE_PARTNER_SHEET_SETUP_KEY,
    JSON.stringify(setup),
  );
}

/* Reading clears the stash so an abandoned setup cannot be picked up later */
export function takeOfflineSheetSetup(): OfflineSheetSetupType | null {
  const stored = sessionStorage.getItem(OFFLINE_PARTNER_SHEET_SETUP_KEY);
  sessionStorage.removeItem(OFFLINE_PARTNER_SHEET_SETUP_KEY);
  if (!stored) return null;
  try {
    return JSON.parse(stored);
  } catch (err) {
    return null;
  }
}
